// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { Button, Card, Modal } from "antd";
// import {
//   CalendarOutlined,
//   ClockCircleOutlined,
//   EnvironmentOutlined,
// } from "@ant-design/icons";
// import dayjs from "dayjs";
// import { useTranslation } from "react-i18next";

// const ConsulterDetailsCalendrierExamenRattrapage = ({calendarData,openModal, setOpenModal, }) => {
//   // const [calendarData, setCalendarData] = useState([]);
//   const params = useLocation();
//   const result = params.state?.result;
//   console.log("calendarData",calendarData)
//   const { t } = useTranslation();


//   return (



//         <Modal
//       title={t(``)}
//       open={openModal}
//       width={ 800}
//       onCancel={() => setOpenModal(false)}
//       footer={[
//         <Button key="cancel" onClick={() => setOpenModal(false)}>
//           Annuler
//         </Button>,
       
//       ]}
//     >
//         <div style={{ padding: "24px" }}>
//       {calendarData?.length && (
//         <>
//           {calendarData?.map((item, index) => {
//             const color = item.type === "examen" ? "#2a96ff" : "#ffb836";
//             const bgColor = item.type === "examen" ? "#f0f5ff" : "#fff7e6";
//             const borderColor = item.type === "examen" ? "#6197cb" : "#ffd591";

//             return (
//               <>
//           <h2  style={{
//                   color,
//                   marginBlock: 10,
//                   fontSize: 20,
//                   fontWeight: "bold",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 8,
//                 }}>
//             <CalendarOutlined /> { item.type === "examen" ? "Calendrier Examen" : "Calendrier Rattrapage"}
//           </h2>
//               <Card
//                 key={index}
//                 title={
//                   <span style={{ fontWeight: "bold", color }}>
//                     {dayjs(item.date_exam)
//                       .format("dddd DD/MM/YYYY")
//                       .replace(/^./, (c) => c.toUpperCase())}
//                   </span>
//                 }
//                 size="small"
//                 style={{
//                   marginBottom: 20,
//                   backgroundColor: bgColor,
//                   border: `1px solid ${borderColor}`,
//                   borderRadius: 12,
//                   boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
//                 }}
//               >
//                 <div
//                   style={{
//                     padding: 10,
//                     backgroundColor: "#fff",
//                     borderRadius: 8,
//                     marginBottom: 8,
//                     border: "1px solid #f0f0f0",
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 24,
//                     fontSize: 14,
//                     fontWeight: 500,
//                     flexWrap: "wrap",
//                   }}
//                 >
//                   <span>
//                     {item.module_key} : {item.name_module}
//                   </span>

//                   <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
//                     <ClockCircleOutlined style={{ color: "#ff808B" }} />{" "}
//                     {item.heure_deb_exam} à {item.heure_fin_exam}
//                   </span>

//                   <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
//                     <EnvironmentOutlined style={{ color: "#ff808B" }} />{" "}
//                     Salle : {item.salle_exam}
//                   </span>
//                 </div>
//               </Card>
//               </>
//             );
//           })}
//         </>
//       )}
//     </div>
//     </Modal>




//   );
// };

// export default ConsulterDetailsCalendrierExamenRattrapage;


import { useLocation } from "react-router-dom";
import { Button, Card, Modal } from "antd";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const ConsulterDetailsCalendrierExamenRattrapage = ({ calendarData, openModal, setOpenModal }) => {
  const params = useLocation();
  const result = params.state?.result;
  const { t } = useTranslation();

  // Grouper les éléments par type
  const groupedData = calendarData?.reduce((acc, item) => {
    const type = item.type || "autre";
    if (!acc[type]) {
      acc[type] = [];
    }
    acc[type].push(item);
    return acc;
  }, {});

  const typeLabels = {
    examen: "Calendrier Examen",
    rattrapage: "Calendrier Rattrapage",
  };

  const typeColors = {
    examen: {
      color: "#2a96ff",
      bgColor: "#f0f5ff",
      borderColor: "#6197cb",
    },
    rattrapage: {
      color: "#ffb836",
      bgColor: "#fff7e6",
      borderColor: "#ffd591",
    },
  };

  return (
    <Modal
      title={t("")}
      open={openModal}
      width={800}
      onCancel={() => setOpenModal(false)}
      footer={[
        <Button key="cancel" onClick={() => setOpenModal(false)}>
          Annuler
        </Button>,
      ]}
    >
      <div style={{ padding: "24px" }}>
        {groupedData &&
          Object.entries(groupedData).map(([type, items]) => {
            const { color, bgColor, borderColor } = typeColors[type] || {};

            return (
              <div key={type}>
                <h2
                  style={{
                    color,
                    marginBlock: 10,
                    fontSize: 20,
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <CalendarOutlined /> {typeLabels[type] || "Calendrier"}
                </h2>

                {items.map((item, index) => (
                  <Card
                    key={index}
                    title={
                      <span style={{ fontWeight: "bold", color }}>
                        {dayjs(item.date_exam)
                          .format("dddd DD/MM/YYYY")
                          .replace(/^./, (c) => c.toUpperCase())}
                      </span>
                    }
                    size="small"
                    style={{
                      marginBottom: 20,
                      backgroundColor: bgColor,
                      border: `1px solid ${borderColor}`,
                      borderRadius: 12,
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                    }}
                  >
                    <div
                      style={{
                        padding: 10,
                        backgroundColor: "#fff",
                        borderRadius: 8,
                        marginBottom: 8,
                        border: "1px solid #f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        gap: 16,
                        fontSize: 14,
                        fontWeight: 500,
                        flexWrap: "wrap",
                      }}
                    >
                      <span>
                        {item.module_key} : {item.name_module}
                      </span>

                        <span>
                        <EnvironmentOutlined style={{ color: "#ff808B" }} /> Seuil : {item.seuil}  {item.unite_seuil}
                      </span>

                      <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <ClockCircleOutlined style={{ color: "#ff808B" }} /> Durée :{item.heure_deb_exam} - {item.heure_fin_exam}
                      </span>

                      <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <EnvironmentOutlined style={{ color: "#ff808B" }} /> Salle : {item.salle_exam}
                      </span>
                    </div>
                  </Card>
                ))}
              </div>
            );
          })}
      </div>
    </Modal>
  );
};

export default ConsulterDetailsCalendrierExamenRattrapage;
